import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Stack,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { snackbarUtils } from "../../utils";
import { useUsers } from "../../hooks/useUsers";
import { useCreateOrganisation } from "../../hooks/useOrganisations";

export default function OrganisationAddDialog(props) {
  const { open, handleClose, user_id } = props;

  const [organisation, setOrganisation] = useState({
    name: "",
    description: "",
    owner_id: user_id,
  });

  const { data: users } = useUsers();
  const createOrganisationMutation = useCreateOrganisation();

  const addOrganisation = () => {
    //check for name, description and owner_id
    if (!organisation.name) {
      snackbarUtils.showError("Organisation name cannot be blank");
      return;
    }

    if (!organisation.description) {
      snackbarUtils.showError("Organisation description cannot be blank");
      return;
    }

    if (!organisation.owner_id) {
      snackbarUtils.showError("Organisation owner cannot be blank");
      return;
    }

    //create organisation using React Query mutation
    createOrganisationMutation.mutate(organisation, {
      onSuccess: () => {
        snackbarUtils.showSuccess("Organisation added successfully");
        handleClose();
      },
      onError: (error) => {
        if (error.response?.status === 409) {
          snackbarUtils.showError("Organisation already exists");
        } else {
          snackbarUtils.showError("Failed to add organisation");
        }
      },
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxSize="sm">
      <DialogTitle>Add Organisation</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <FormControl fullWidth>
            <TextField
              id="name"
              label="Organisation Name"
              variant="outlined"
              required
              fullWidth
              autoFocus
              onChange={(e) => {
                setOrganisation({ ...organisation, name: e.target.value });
              }}
            />
          </FormControl>
          <FormControl fullWidth>
            <TextField
              id="description"
              label="Description"
              variant="outlined"
              required
              fullWidth
              onChange={(e) => {
                setOrganisation({
                  ...organisation,
                  description: e.target.value,
                });
              }}
            />
          </FormControl>
          <FormControl fullWidth>
            <Autocomplete
              id="owner"
              options={users || []}
              value={
                users?.find(
                  (user) => user.id === parseInt(organisation.owner_id)
                ) || null
              }
              getOptionLabel={(option) => option.email || ""}
              onChange={(e, value) => {
                setOrganisation({
                  ...organisation,
                  owner_id: value ? value.id : "",
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Owner"
                  variant="outlined"
                  required
                />
              )}
            />
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={addOrganisation}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
